import _typeof from "@babel/runtime/helpers/esm/typeof";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var addToWishlist = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _window;
    var gtin, productCode, queryClient, _yield$import, getAddToWishlistOptions, variables, data;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          gtin = _ref.gtin, productCode = _ref.productCode;
          queryClient = (_window = window) === null || _window === void 0 || (_window = _window.NikeShop) === null || _window === void 0 || (_window = _window.__INTERNAL_USE__) === null || _window === void 0 ? void 0 : _window.queryClient;
          if (queryClient) {
            _context.next = 1;
            break;
          }
          throw new Error('NikeShop queryClient is unavailable for addToWishlist');
        case 1:
          _context.next = 2;
          return Promise.resolve().then(function () {
            return _interopRequireWildcard(require('@nike/shop-apis/buy/wishlists/v2/lists/items/add/get-options'));
          });
        case 2:
          _yield$import = _context.sent;
          getAddToWishlistOptions = _yield$import["default"];
          variables = {
            gtin: gtin,
            productCode: productCode
          };
          _context.next = 3;
          return queryClient.getMutationCache().build(queryClient, _objectSpread(_objectSpread({}, getAddToWishlistOptions({
            queryClient: queryClient
          })), {}, {
            variables: variables
          })).execute();
        case 3:
          data = _context.sent;
          return _context.abrupt("return", {
            type: '@wishlist/ADD_TO_WISHLIST_SUCCESS',
            payload: {
              id: data === null || data === void 0 ? void 0 : data.id
            }
          });
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function addToWishlist(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export default addToWishlist;